export default "__VITE_PUBLIC_ASSET__e88fbca3__"